import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ColumnModel } from '@/features/crm/types';

async function getMatriculas(startDate: string, endDate: string): Promise<ColumnModel[]> {
  const api = await getApi();
  const { data } = await api.get(`/crm/dashboard/${startDate}/${endDate}/`, {
    params: {
    }
  });
  return data;
}

type QueryFnType = typeof getMatriculas;

function useDashboardCrm(startDate: string, endDate: string) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-crm-dashboard'],
    queryFn: () => getMatriculas(startDate, endDate),
  });
}

export { getMatriculas, useDashboardCrm };
